import { useQuery } from '@tanstack/react-query';
import { fetchConfigOption } from '../services/smr-admin';
import { configOptionKeys } from './useConfigOptionsQuery';

export const useConfigOptionQuery = (id?: string) =>
    useQuery({
        queryKey: configOptionKeys.detail(id ?? ''),
        queryFn: () => fetchConfigOption(id as string),
        enabled: Boolean(id),
    });
